import { render, staticRenderFns } from "./AdminStatistics.vue?vue&type=template&id=5f69bd59&scoped=true"
import script from "./AdminStatistics.vue?vue&type=script&lang=js"
export * from "./AdminStatistics.vue?vue&type=script&lang=js"
import style0 from "./AdminStatistics.vue?vue&type=style&index=0&id=5f69bd59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f69bd59",
  null
  
)

export default component.exports